// official: 正式的
export enum PageId {
  SALE_NOT_PASS = 'S_N_P', // 评审单
  SALE_OFFICIAL = 'S_O',
  SALE_CUSTOMER = 'S_C',
  SALES_PRODUCT_INFO = 'S_P_I',
  MC_NOT_PASS = 'MC_N_P',
  MC_PASSED = 'MC_P',
  MC_BE_REJECT = 'MC_B_R',
  MC_OFFICIAL_PENDING = 'MC_O_P',
  MC_OFFICIAL_DONE = 'MC_O_D',
  MC_OFFICIAL_CLOSED = 'MC_O_C',
  MC_BOM = 'MC_B',
  MC_REQ_MANAGE = 'MC_REQ_MANAGE',
  MC_REQ_M = 'MC_REQ_M', // 备料计划
  COMMODITY_NOT_PASS = 'CMD_N_P',
  COMMODITY_PASSED = 'CMD_P',
  COMMODITY_BE_REJECT = 'CMD_B_R',
  COMMODITY_OFFICIAL_PENDING = 'CMD_O_P',
  COMMODITY_OFFICIAL_DONE = 'CMD_O_D',
  COMMODITY_OFFICIAL_CLOSED = 'CMD_O_C',
  COMMODITY_ENTER_DATA = 'CMD_E_D',
  COMMODITY_DATA_MT = 'CMD_D_MT',
  PROD_NOT_PASS = 'PR_N_P',
  PROD_PASSED = 'PR_P',
  PROD_BE_REJECT = 'PR_B_R',
  PROD_OFFICIAL_PENDING = 'PR_O_P',
  PROD_OFFICIAL_DONE = 'PR_O_D',
  PROD_OFFICIAL_CLOSED = 'PR_O_C',
  PROD_ENTER_DATA = 'PR_E_D',
  PROD_DATA_MT = 'PR_D_MT',
  PROD_MATERIAL_OVER_ISSUE = 'PR_M_O_I', // 超领申请
  PUR_NOT_PASS = 'PUR_N_P',
  PUR_PASSED = 'PUR_P',
  PUR_BE_REJECT = 'PUR_B_R',
  PUR_ALL_QUTATION = 'PUR_A_Q',
  PUR_OFFICIAL_PENDING = 'PUR_O_P',
  PUR_OFFICIAL_DONE = 'PUR_O_D',
  PUR_OFFICIAL_CLOSED = 'PUR_O_C',
  PUR_ORDER_PENDING_PAY = 'PUR_ORDER_PENDING',
  PUR_ORDER_PAYED = 'PUR_ORDER_PAYED',
  PUR_ORDER_DONE = 'PUR_ORDER_DONE',
  PUR_HELP_ACCEPT = 'PUR_HELP_ACCEPT',
  PUR_SUPPLIER = 'PUR_SUP',
  PUR_PRICES = 'PUR_PRICES', // 采购管理 - 报价列表
  PUR_DIS_SUPPLIER = 'PUR_DIS_SUP',
  PUR_ALL_PASSED = 'P_A_P',
  PUR_ZF = 'PUR_ZF',
  PUR_OM = 'PUR_OM',
  PUR_MT = 'PUR_MT',
  PUR_RT = 'PUR_RT',
  PUR_INV_ITEM = 'PUR_I_I',
  F_NOT_PASS = 'F_N_P',
  F_PASSED = 'F_P',
  F_BE_REJECT = 'F_B_R',
  F_SALE_OFFICIAL = 'F_S_O', // 财务管理 - 销售正式订单
  F_OFFICIAL_PENDING = 'F_O_P',
  F_OFFICIAL_DONE = 'F_O_D',
  F_OFFICIAL_CLOSED = 'F_O_C',
  WAREHOUSE_INVENTORY = 'W_I',
  WAREHOUSE_INVENTORY_HIS = 'W_I_H',
  WAREHOUSE_INVENTORY_COUNTING = 'W_I_C',
  WAREHOUSE_INVENTORY_IN = 'W_I_I',
  WAREHOUSE_INVENTORY_OUT = 'W_I_O',
  WAREHOUSE_INVENTORY_DETAIL = 'W_I_D',
  LOC_INV_DTL = 'LOC_INV_DTL',
  PACKING = 'W_P',
  DATA_PROD_DATA = 'D_PR_D',
  ORG_MANA = 'ORG_MANA',
  MEMBER_ENABLED = 'M_EN',
  MEMBER_DISABLED = 'M_DID',
  PRODUCT_CATEGORY = 'PRO_CATE',
  PRODUCT_LIST = 'PRO_L',
  APP_LIST = 'A_L',
  DATA_MANAGE_SUPPLIER = 'D_M_S',
  REIMBURSE_MINE = 'REIM_M',
  REIMBURSE_APPROVE = 'REIM_APV',
  REIMBURSE_ALL = 'REIM_AL',
  WAREHOUSE_LOCATION_REF_PRODUCTS = 'W_L_R_P',
  MATERIAL_INVENTORY_ALERT = 'M_I_A',
  WAREHOUSE_IQC = 'W_IQC',
  FAC_INVENTORY = 'FAC_INVENTORY',
  SHIPMENT_LIST = 'SHIPMENT_LIST',
  INSPECTION = 'INSP',
  INSPECTION_ITEM = 'INSP_I',
  EQUIPMENT = 'EQUIPMENT',
}

export enum PageType {
  SALE = 'S',
  PURCHASE = 'P',
  PROD = 'PR',
  FINANCE = 'F',
  MATERIAL_CONTROL = 'MC',
  COMMODITY = 'CMD'
}
